import * as React from "react";
import dayjs from "dayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import FocusTrap from "@mui/material/Unstable_TrapFocus";


export default function TimePickerModule({
  visibility,
  defaultValue,
  onChangeDate,
  onChangeTime,
  onDone,
  setNewData,
  selectedDate,
  ...props
}) {
  const today = dayjs()
  const [value, setValue] = React.useState(dayjs(`${today.format('YYYY-MM-DD')}T${defaultValue}`));
// console.log(value)
  // React.useEffect(() => {
  //   setValue(defaultValue)
  // }, [defaultValue]);
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} style={{zIndex:100000}}>
      {/* <DemoItem label="Desktop variant">
          <DesktopTimePicker defaultValue={dayjs('2022-04-17T15:30')} />
        </DemoItem> */}
      {defaultValue !== null && (
            <FocusTrap >
        <DemoItem>
          <MobileTimePicker
            value={value}
            onChange={(newValue) => {
              setValue(newValue);
              // console.log(
              //   dayjs(newValue, { format: "HH:mm" }).format("hh:mm:ss A")
              // );
              setNewData(
                dayjs(newValue, { format: "HH:mm" }).format("hh:mm:ss A")
              );
            }}
            {...props}
            PopperProps={{
               style: { zIndex: 1000000}}}
            slotProps={{
              textField: {
                InputProps: {
                  className: "description_inputf",
                  color: "primary",
                  variant: "plain",
                  endAdornment: (
                    <img src="images/clock.png" className="clock_icon" alt="calender" />
                  ),
                },
              },
            }}
          />
        </DemoItem>
        </FocusTrap>
      )}
      {/* <DemoItem label="Responsive variant">
          <TimePicker defaultValue={dayjs('2022-04-17T15:30')} />
        </DemoItem>
        <DemoItem label="Static variant">
          <StaticTimePicker defaultValue={dayjs('2022-04-17T15:30')} />
        </DemoItem> */}
    </LocalizationProvider>
  );
}